import React, { useEffect } from "react";
import { useSubheader } from "../../_metronic/layout";
import { Setting } from "../../_metronic/_partials/settings/Setting";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { fetchPermission } from "./redux/permission";

export const Settings = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchPermission());
  }, [dispatch]);
  const intl = useIntl();
  const { setTitle } = useSubheader();
  const title = intl.formatMessage({ id: "SETTINGS" });
  useEffect(() => {
    setTitle(title);
  }, [setTitle, title]);
  return <Setting />;
};
